import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIdentity } from '@dialectlabs/react-sdk';
import clsx from 'clsx';
import { LinkifiedText } from '../../components/common';
import { Img, P } from '../../components/common/preflighted';
import { useTheme } from '../../components/common/providers/DialectThemeProvider';
import { shortenAddress } from '../../utils/displayUtils';
const timeFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});
const NotificationAuthor = ({ author }) => {
    var _a;
    const { textStyles, notificationAuthor } = useTheme();
    const { identity } = useIdentity({ address: author });
    return (_jsx("div", { className: notificationAuthor, children: _jsxs(P, { className: clsx('dt-flex dt-flex-row dt-items-center', textStyles.label), children: [((_a = identity === null || identity === void 0 ? void 0 : identity.additionals) === null || _a === void 0 ? void 0 : _a.avatarUrl) && (_jsx(Img, { className: "dt-rounded-full dt-w-[1em] dt-h-[1em] dt-mr-1", alt: `dapp-${identity.name}`, src: identity.additionals.avatarUrl })), _jsx("span", { children: (identity === null || identity === void 0 ? void 0 : identity.name) || shortenAddress(author.toString()) })] }) }));
};
export const Notification = ({ author, message, timestamp }) => {
    const { colors, textStyles, notificationMessage, notificationTimestamp } = useTheme();
    return (_jsxs("div", { className: clsx('dt-flex dt-flex-col', colors.highlight, notificationMessage), children: [author && _jsx(NotificationAuthor, { author: author }), _jsx("div", { className: "dt-flex-1 dt-mb-2", children: _jsx(P, { className: clsx(textStyles.body, 'dt-break-words dt-whitespace-pre-wrap dt-font-medium dt-text-base'), children: _jsx(LinkifiedText, { children: message }) }) }), _jsx("div", { className: notificationTimestamp, children: _jsx(P, { className: clsx(textStyles.small, 'dt-opacity-60'), children: timeFormatter.format(timestamp) }) })] }));
};
//# sourceMappingURL=Notification.js.map